(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('preloader', function() {
        return {
            restrict: 'E',
            replace: true,
            template: '<div class="preloader">' +
                        '<div class="cell cell-1"></div>' +
                        '<div class="cell cell-2"></div>' +
                        '<div class="cell cell-3"></div>' +
                        '<div class="cell cell-4"></div>' +
                        '<div class="cell cell-5"></div>' +
                        '<div class="cell cell-6"></div>' +
                        '<div class="cell cell-7"></div>' +
                        '<div class="cell cell-8"></div>' +
                    '</div>'
        };
    }
);
})();
